import { VendorDetailAction } from "../../actions/vendor/VendorDetailAction";
import { UserFile } from "../../models/UserFile";
import { VendorPo } from "../../models/VendorPo";
import { Company } from "../../models/Company";
import { any } from "video.js/dist/types/utils/events";
import CommercialDetails from "../../pages/Vendor/VendorDetail/Commercial";
import { MiscellaneousServicesSharp } from "@mui/icons-material";

export interface EmailNote {
  emailAddress: string;
  note: string;
}

export interface MobileNo {
  mobileNumber: string;
  isChecked: boolean;
}

export interface VendorBankDetail {
  id: number;
  bankCountry: string;
  beneficiaryAccName: string;
  beneficiaryAddress: string;
  bankAccNumber: string;
  bankACKey: string;
  bankAcKeyDesc: String;
  accCurrency: string;
  bankName: string;
  // BankNameOther: string;
  bankAddress: string;
  sortCode: string;
  swiftCode: string;
  ibanCode: string;
  bankNumber: string;
  bankBranch: string;
  modifiedStatus: number
  noObjectionLetterFile: UserFile;
  bankStatementFile: UserFile;
  bankConfirmationFile: UserFile;
  //BankNumberOther: string;
}

export interface CommercialDetail
{
   id: number;
   materialRef:string;
   materialDescription:string;
   uom:string;
   price:number;
   priceUnit:number;
   creditterm:string;
   modifiedStatus: boolean;
}

export interface AdditionalDocumentDetail{
  tempid: number;
  uploadType:string;
  uploadTypeId:number;
  file:UserFile;
}

export interface MillEvaluationFormDetail{
  id: number;
  millEvaluationId:number;
  millEvaluationName:string;
  rmCategoryName:string;
  uploadTypeId:number;
  uploadType:string;
  uploadFile:UserFile;
  downloadFile:UserFile;
  downloadDocumentName:string;
  rating:number;
}

export interface VendorOnBoardReason{
  id: number;
  vendorId:number;
  onBoardingReasonId:string;
  onBoardingReasonName:string;
}

export interface VendorDetailState {
  [key: string]: any;
  VendorId: number;
  VendorNo: string;
  RequestNumber: string;
  Comment: string;
  VendorName: string;
  NatureOfbusiness: string;
  Title: string;
  PurposePayment: string;
  BusRegNumber: string;
  vendorNic: string;
  //IsMASEmployee: boolean;
  EmployeeEPF: string;
  AddressNumberStreet: string;
  AddressPostalCode: string;
  AddressCity: string;
  AddressCoutry: string;
  RegionCode: string;
  PaymentContactPersonName: string;
  PaymentContactPersonName2: string;
  PaymentContactPersonDesig: string;
  MobileNumbers: Array<MobileNo>;
  MobileNumberText: string;
  EmailNoteList: Array<EmailNote>;
  CompanyWebSite: string;
  PrefCommunMethod: string;
  isIndividualPayement: boolean;
  //IsForeignSupplier: boolean;
  TermsOfTrade: string;
  PrefPayMethod: string[];
  CreditPeriodDays: string;
  alternativeCurrency: string[];
  //SettlementCurency: string[];
  VATRegisterd: boolean;
  SVATRegistered: boolean;
  SVATType: string;
  SVATContactNumber: string;
  SVATContactEmail: string;
  VATNumber: string;
  SVATNumber: string;
  SWATType: string;
  TinNic: string;
  Tax1099: string;
  TaxConPersnName: string;
  TaxConPersnConNum: string;
  LiableForWHT: boolean;
  WHTCountry: string;
  WHTType: string;
  WHTCode: string;
  ExemptionNumber: string;
  Exemption: string;
  ExemptFrom: string;
  ExemptTo: string;
  Discription: string;
  ForeignEntityReq: boolean;
  AvailabilityDT: string;
  TaxRateDT: string;
  PANNumber: string;
  TaxNumber: string;
  CBIDCode: string;
  InstructionKey: string;
  HouseBank: string;
  ReconAC: string;
  PurposeCode: string;
  HoBeneficiaryCatIndo: string,
  HopurposeofTransIndo: string,
  HoBeneAffiliationStatusIndo: string,
  HoPayableLocationIndia: string,
  HoPurposePayIndia: string,
  simodis: string,
  //CoCodeCountry: string,
  AccoutingClark: string;
  AccoutingEmail: string;
  IsSubmited: boolean;
  CurrentApprovalPointId: number;
  isVendorFillForm2: boolean;
  requestStatusId: number;
  //incoterms:string;
  //schemaGroup:string;
  CompanyCode: Company;
  requestId: number;
  poCodes: VendorPo[];
  rejectReason: string;
  requestTypeId: number;
  permittedPayeeList: string[];
  orderCurrency: string;
  bankDetailList: VendorBankDetail[];
  commercialDetailList: CommercialDetail[];
  trc: string;
  sortKey: string;
  VatFile: UserFile;
  SvatFile: UserFile;
  TinFile: UserFile;
  Tax1099File: UserFile;
  WhtFile: UserFile;
  PanFile: UserFile;
  TaxFile: UserFile;
  Extra1File: UserFile;
  Extra2File: UserFile;
  BrFile: UserFile;
  NicFile: UserFile;
  TrcFile: UserFile;
  BlackListFile: UserFile;
  SupportAdditionalFile1: UserFile;
  SupportAdditionalFile2: UserFile;
  VendorSignedFile: UserFile;
  //request preparer
  FilledByName: string;
  FilledByEmail: string;
  FilledByMobile: string;
  FilledByDesignation: string;
  CallerVerifierName: string;
  CallerVerifierDesignation: string;
  CallerVerifiedDate: Date | null;
  ApproverNames: string[];
  estimatedSalesTurnover: number;
  noOfInvoicesPerMonth: number;
  supplierCBankName: string;
  supplierCBankAccountSWIFT: string;
  descOfGoods: string;
  offShoreSupplierHSCode: string;
  accountCurrency: string;
  currencyId: string;
  originalVendorName : string;
  originalNatureOfbusiness : string;
  originalBusRegNumber : string;
  additionalDocumentList: AdditionalDocumentDetail[];
  millEvaluationFormList : MillEvaluationFormDetail[];
  vendorCategoryId:number;
  isBulk:boolean;
  vendorOnBoardReasonList: VendorOnBoardReason[];
  tempApprovalDays: number | null;
}

const getInitialState = () => {
  return {
    VendorId: 0,
    VendorNo: "",
    RequestNumber: "",
    Comment: "",
    VendorName: "",
    NatureOfbusiness: "",
    Title: "",
    PurposePayment: "",
    BusRegNumber: "",
    vendorNic: "",
    //IsMASEmployee: false,
    EmployeeEPF: "",
    AddressNumberStreet: "",
    AddressPostalCode: "",
    AddressCity: "",
    AddressCoutry: "",
    RegionCode: "",
    PaymentContactPersonName: "",
    PaymentContactPersonName2: "",
    PaymentContactPersonDesig: "",
    MobileNumbers: [],
    MobileNumberText: "",
    EmailNoteList: [],
    CompanyWebSite: "",
    PrefCommunMethod: "",
    //IsForeignSupplier: false,
    TermsOfTrade: "",
    PrefPayMethod: [],
    CreditPeriodDays: "",
    //SettlementCurency: [],
    alternativeCurrency: [],
    VATRegisterd: false,
    SVATRegistered: false,
    SVATType: "",
    SVATContactNumber: "",
    SVATContactEmail: "",
    VATNumber: "",
    SVATNumber: "",
    SWATType: "",
    TinNic: "",
    Tax1099: "",
    TaxConPersnName: "",
    TaxConPersnConNum: "",
    LiableForWHT: false,
    WHTCountry: "",
    WHTType: "",
    WHTCode: "",
    ExemptionNumber: "",
    Exemption: "",
    ExemptFrom: "",
    ExemptTo: "",
    Discription: "",
    ForeignEntityReq: false,
    AvailabilityDT: "",
    TaxRateDT: "",
    PANNumber: "",
    TaxNumber: "",
    CBIDCode: "",
    InstructionKey: "",
    HouseBank: "",
    ReconAC: "",
    PurposeCode: "",
    HoBeneficiaryCatIndo: "",
    HopurposeofTransIndo: "",
    HoBeneAffiliationStatusIndo: "",
    HoPayableLocationIndia: "",
    HoPurposePayIndia: "",
    simodis: "",
    //CoCodeCountry:"",
    AccoutingClark: "",
    AccoutingEmail: "",
    IsSubmited: false,
    CurrentApprovalPointId: 0,
    isVendorFillForm2: false,
    isIndividualPayement: false,
    requestStatusId: 0,
    // incoterms:"",
    // schemaGroup:"",
    CompanyCode: { code: "", name: "", countryCode: "", isWhtAvailable: false },
    requestId: 0,
    poCodes: [],
    rejectReason: "",
    requestTypeId: 0,
    permittedPayeeList: [],
    orderCurrency: "",
    bankDetailList: [],
    commercialDetailList:[],
    additionalDocumentList:[],
    millEvaluationFormList:[],
    vendorOnBoardReasonList:[],
    trc: "",
    sortKey: "",
    VatFile: { fileId: 0, fileName: "", filePath: "" },
    SvatFile: { fileId: 0, fileName: "", filePath: "" },
    TinFile: { fileId: 0, fileName: "", filePath: "" },
    Tax1099File: { fileId: 0, fileName: "", filePath: "" },
    WhtFile: { fileId: 0, fileName: "", filePath: "" },
    PanFile: { fileId: 0, fileName: "", filePath: "" },
    TaxFile: { fileId: 0, fileName: "", filePath: "" },
    Extra1File: { fileId: 0, fileName: "", filePath: "" },
    Extra2File: { fileId: 0, fileName: "", filePath: "" },
    BrFile: { fileId: 0, fileName: "", filePath: "" },
    NicFile: { fileId: 0, fileName: "", filePath: "" },
    TrcFile: { fileId: 0, fileName: "", filePath: "" },
    BlackListFile: { fileId: 0, fileName: "", filePath: "" },
    SupportAdditionalFile1: { fileId: 0, fileName: "", filePath: "" },
    SupportAdditionalFile2: { fileId: 0, fileName: "", filePath: "" },
    VendorSignedFile: { fileId: 0, fileName: "", filePath: "" },
    FilledByName: "",
    FilledByEmail: "",
    FilledByMobile: "",
    FilledByDesignation: "",
    CallerVerifierName: "",
    CallerVerifierDesignation: "",
    CallerVerifiedDate: null,
    ApproverNames: [],
    estimatedSalesTurnover: 0,
    noOfInvoicesPerMonth: 0,
    supplierCBankName: '',
    supplierCBankAccountSWIFT: '',
    descOfGoods: '',
    offShoreSupplierHSCode: '',
    accountCurrency: '',
    currencyId:'',
    originalVendorName : '',
    originalNatureOfbusiness : '',
    originalBusRegNumber : '',
    vendorCategoryId:0,
    isBulk:false,
    tempApprovalDays: null
  };
};

export function VendorDetailReducer(
  state: VendorDetailState = getInitialState(),
  action: VendorDetailAction
): VendorDetailState {
  switch (action.type) {
    case "ON_CHANGE_VENDOR_DETAIL_DATA":
      if (
        action.payload[0] === "VendorName" &&
        action.payload[1] === state.beneficiaryAccName
      ) {
        return {
          ...state,
          VendorName: action.payload[1],
          beneficiaryAddress:
            state.AddressNumberStreet +
            "," +
            state.AddressPostalCode +
            "," +
            state.AddressCity +
            "," +
            state.AddressCoutry +
            "," +
            state.RegionCode,
        };
      }
      return {
        ...state,
        [action.payload[0]]: action.payload[1],
      };
      case "ON_CLEAR_VENDOR_BANK_FIELD":
          let bIndex =  state.bankDetailList.findIndex((bank) => {
            return bank.id === action.payload[0];
          });
          let bItems = [...state.bankDetailList];
          let bItem = {...bItems[bIndex]};
          if(action.payload[1] === "beneficiaryAccName"){
             bItem.beneficiaryAccName = "";
          } else if(action.payload[1] === "bankAccNumber"){
            bItem.bankAccNumber = "";
          }
          state.bankDetailList[bIndex] = bItem;
          return {
            ...state,
            bankDetailList: [
              ...state.bankDetailList,
            ]
      };
    // case "ON_CHANGE_VENDOR_DETAIL_BANKDETAILS":

    //   // return {
    //   //     ...state,
    //   //   "BankACKey": action.payload[0],
    //   //   "BankName":action.payload[1],
    //   //   "BankNumber":action.payload[2],
    //   //   "BankNameOther":action.payload[3],
    //   //   "BankNumberOther":action.payload[4]
    //   //   };

    //   return {
    //     ...state,
    //   "bankACKey": action.payload[0],
    //   "bankName":action.payload[1],
    //   //"BankNameOther":action.payload[2],
    //   "bankAddress":action.payload[2],
    //   "bankNumber":action.payload[3],
    //   "swiftCode":action.payload[4]
    //   };

    case "ON_REMOVE_VENDOR_DETAIL_SETTLEMENT_CURRENCY":
      return {
        ...state,
        alternativeCurrency: state.alternativeCurrency.filter((code) => {
          return code !== action.payload[0];
        }),
      };
    case "ON_ADD_VENDOR_DETAIL_MOBILENUMBER":
      return {
        ...state,
        MobileNumbers: [
          ...state.MobileNumbers,
          { mobileNumber: action.payload[0], isChecked: false },
        ],
      };
    case "ON_UPDATE_CHECKED_STATUS_VENDOR_DETAIL_MOBILE":
      let index = state.MobileNumbers.findIndex((mobile) => {
        return mobile.mobileNumber === action.payload[0];
      });
      let items = [...state.MobileNumbers];
      let item = { ...items[index] };
      item.isChecked = action.payload[1];
      state.MobileNumbers[index] = item;
      return {
        ...state,
        MobileNumbers: [
          ...state.MobileNumbers,
        ]
      };
    case "ON_REMOVE_VENDOR_DETAIL_MOBILE_NUMBER":
      return {
        ...state,
        MobileNumbers: state.MobileNumbers.filter(
          (data) => data.mobileNumber !== action.payload[0]
        ),
      };
    case "ON_ADD_VENDOR_DETAIL_EMAILNOTE":
      return {
        ...state,
        EmailNoteList: [
          ...state.EmailNoteList,
          { emailAddress: action.payload[0], note: action.payload[1] },
        ],
      };
    case "ON_REMOVE_VENDOR_DETAIL_EMAILNOTE":
      return {
        ...state,
        EmailNoteList: state.EmailNoteList.filter(
          (data) => data.emailAddress !== action.payload[0]
        ),
      };
    case "ON_STATUS_UPDATE_VENDOR_DETAIL":
      return {
        ...state,
        IsSubmited: action.payload[0],
      };
    case "ON_SUCCESS_VENDOR_DETAIL_GET":
      var initialState = getInitialState();
      var vendorDetails = {
        ...state,
        VendorId: action.payload.vendorId,
        RequestNumber: action.payload.requestNumber,
        Comment: action.payload.comment,
        VendorName: action.payload.vendorName,
        NatureOfbusiness: action.payload.natureOfbusiness,
        Title: action.payload.title,
        PurposePayment: action.payload.purposePayment,
        BusRegNumber: action.payload.busRegNumber,
        vendorNic: action.payload.vendorNic,
        //IsMASEmployee: action.payload.isMASEmployee,
        EmployeeEPF: action.payload.employeeEPF,
        AddressNumberStreet: action.payload.addressNumberStreet,
        AddressPostalCode: action.payload.addressPostalCode,
        AddressCity: action.payload.addressCity,
        AddressCoutry: action.payload.addressCoutry,
        RegionCode: action.payload.regionCode,
        PaymentContactPersonName: action.payload.paymentContactPersonName,
        PaymentContactPersonName2: action.payload.paymentContactPersonName2,
        PaymentContactPersonDesig: action.payload.paymentContactPersonDesig,
        MobileNumbers: action.payload.mobileNumbers,
        MobileNumberText: action.payload.mobileNumbers ? action.payload.mobileNumbers.map((c:any) => c.mobileNumber).join(",") : "",
        EmailNoteList: action.payload.emailNoteList,
        CompanyWebSite: action.payload.companyWebSite,
        PrefCommunMethod: action.payload.prefCommunMethod,
        //IsForeignSupplier: action.payload.isForeignSupplier,
        TermsOfTrade: action.payload.termsOfTrade,
        PrefPayMethod: action.payload.prefPayMethod,
        CreditPeriodDays: action.payload.creditPeriodDays,
        //SettlementCurency: action.payload.settlementCurency,
        alternativeCurrency: action.payload.alternativeCurrency,
        VATRegisterd: action.payload.vatRegisterd,
        SVATRegistered: action.payload.svatRegistered,
        SVATType: action.payload.svatType,
        SVATContactNumber: action.payload.svatContactNumber
          ? action.payload.svatContactNumber.trim()
          : "",
        SVATContactEmail: action.payload.svatContactEmail,
        VATNumber: action.payload.vatNumber,
        SVATNumber: action.payload.svatNumber,
        SWATType: action.payload.SWATType,
        TinNic: action.payload.tinNic,
        Tax1099: action.payload.tax1099,
        TaxConPersnName: action.payload.taxConPersnName,
        TaxConPersnConNum: action.payload.taxConPersnConNum,
        LiableForWHT: action.payload.liableForWHT,
        WHTCountry: action.payload.whtCountry,
        WHTType: action.payload.whtType,
        WHTCode: action.payload.whtCode,
        ExemptionNumber: action.payload.exemptionNumber,
        Exemption: action.payload.exemption,
        ExemptFrom: action.payload.exemptFrom,
        ExemptTo: action.payload.exemptTo,
        Discription: action.payload.discription,
        ForeignEntityReq: action.payload.foreignEntityReq,
        AvailabilityDT: action.payload.availabilityDT,
        TaxRateDT: action.payload.taxRateDT,
        PANNumber: action.payload.panNumber,
        TaxNumber: action.payload.taxNumber,
        CBIDCode: action.payload.cbidCode,
        InstructionKey: action.payload.instructionKey,
        sortKey: action.payload.sortKey,
        HouseBank: action.payload.houseBank,
        ReconAC: action.payload.reconAC,
        PurposeCode: action.payload.purposeCode,
        HoBeneficiaryCatIndo: action.payload.hobeneficiaryCatIndo,
        HopurposeofTransIndo: action.payload.hopurposeofTransIndo,
        HoBeneAffiliationStatusIndo: action.payload.hobeneAffiliationStatusIndo,
        HoPayableLocationIndia: action.payload.hopayableLocationIndia,
        HoPurposePayIndia: action.payload.hopurposePayIndia,
        simodis: action.payload.simodis,
        //CoCodeCountry : action.payload.coCodeCountry,
        AccoutingClark: action.payload.accoutingClark,
        AccoutingEmail: action.payload.accoutingEmail,
        IsSubmited: action.payload.isSubmited,
        CurrentApprovalPointId: action.payload.currentApprovalPointId,
        isVendorFillForm2: action.payload.isVendorFillForm2,
        isIndividualPayement: action.payload.isIndividualPayement,
        requestStatusId: action.payload.requestStatusId,
        //incoterms:action.payload.incoterms
        //schemaGroup:action.payload.schemaGroup,
        CompanyCode: action.payload.coCodes[0],
        requestId: action.payload.requestId,
        poCodes: action.payload.poCodes,
        rejectReason: action.payload.rejectReason,
        requestTypeId: action.payload.requestTypeId,
        permittedPayeeList: action.payload.permittedPayeeList,
        orderCurrency: action.payload.orderCurrency,
        //bankCountry: action.payload.bankCountry,
        bankDetailList: action.payload.bankDetailList,
        commercialDetailList: action.payload.commercialDetailList,
        trc: action.payload.trc,
        NicFile: action.payload.nicFile ? action.payload.nicFile : initialState.NicFile,
        BrFile: action.payload.brFile ? action.payload.brFile : initialState.BrFile,
        PanFile: action.payload.panFile ? action.payload.panFile : initialState.PanFile,
        TinFile: action.payload.tinFile ? action.payload.tinFile : initialState.TinFile,
        VatFile: action.payload.vatFile ? action.payload.vatFile : initialState.VatFile,
        SvatFile: action.payload.svatFile ? action.payload.svatFile : initialState.SvatFile,
        WhtFile: action.payload.whtFile ? action.payload.whtFile : initialState.WhtFile,
        TaxFile: action.payload.taxFile ? action.payload.taxFile : initialState.TaxFile,
        Extra1File: action.payload.extra1File ? action.payload.extra1File : initialState.Extra1File,
        Extra2File: action.payload.extra2File ? action.payload.extra2File : initialState.Extra2File,
        TrcFile: action.payload.trcFile ? action.payload.trcFile : initialState.TrcFile,
        BlackListFile: action.payload.blackListFile ? action.payload.blackListFile : initialState.BlackListFile,
        Tax1099File: action.payload.tax1099File ? action.payload.tax1099File : initialState.Tax1099File,
        SupportAdditionalFile1: action.payload.supportAdditionalFile1 ? action.payload.supportAdditionalFile1 : initialState.SupportAdditionalFile1,
        SupportAdditionalFile2: action.payload.supportAdditionalFile2 ? action.payload.supportAdditionalFile2 : initialState.SupportAdditionalFile2,
        VendorSignedFile: action.payload.vendorSignedFile ? action.payload.vendorSignedFile : initialState.VendorSignedFile,
        //filledby data
        FilledByName: action.payload.filledByName,
        FilledByEmail: action.payload.filledByEmail,
        FilledByMobile: action.payload.filledByMobile,
        FilledByDesignation: action.payload.filledByDesignation,
        CallerVerifierName: action.payload.callerVerifierName,
        CallerVerifierDesignation:action.payload.callerVerifierDesignation,
        CallerVerifiedDate: action.payload.callerVerifiedDate,
        ApproverNames: action.payload.approverNames,
        estimatedSalesTurnover: action.payload.estimatedSalesTurnover,
        noOfInvoicesPerMonth: action.payload.noOfInvoicesPerMonth,
        supplierCBankName: action.payload.supplierCBankName,
        supplierCBankAccountSWIFT: action.payload.supplierCBankAccountSWIFT,
        descOfGoods: action.payload.descOfGoods,
        offShoreSupplierHSCode: action.payload.offShoreSupplierHSCode,
        accountCurrency: action.payload.accountCurrency,

        originalVendorName : action.payload.originalVendorName,
        originalNatureOfbusiness : action.payload.originalNatureOfbusiness,
        originalBusRegNumber : action.payload.originalBusRegNumber,
        //action.payload.rejectReason
        //poCodes:[{"coCode":"B050", "poCode":"B051"}, {"coCode":"B050", "poCode":"B052"}]
         additionalDocumentList: action.payload.additionalDocumentList,
         millEvaluationFormList : action.payload.millEvaluationFormList,
         vendorCategoryId : action.payload.vendorCategoryId,
         isBulk : action.payload.isBulk,
         vendorOnBoardReasonList:action.payload.vendorOnBoardReasonList,
         tempApprovalDays: action.payload.tempApprovalDays
      };
      //set bank details defaults
      if (vendorDetails.bankDetailList) {
        vendorDetails.bankDetailList.forEach(c => {
          if (!c.noObjectionLetterFile) {
            c.noObjectionLetterFile = { fileId: 0, fileName: "", filePath: "" };
          }
          if (!c.bankStatementFile) {
            c.bankStatementFile = { fileId: 0, fileName: "", filePath: "" };
          }
          if (!c.bankConfirmationFile) {
            c.bankConfirmationFile = { fileId: 0, fileName: "", filePath: "" };
          }
        });
      }
      return vendorDetails;

    case "RESET_DETAIL":
      return Object.assign(state, getInitialState());
    // case "ON_BENEFICIARY_ACCNAME_UPDATE_VENDOR_DETAIL":
    //   if(state.VendorName === action.payload[0]){
    //     return {
    //       ...state,
    //       beneficiaryAccName: action.payload[0],
    //       beneficiaryAddress:state.AddressNumberStreet
    //     };
    //   }
    //   return {
    //     ...state,
    //     beneficiaryAccName: action.payload[0]
    //   };
    case "ON_ORDERCURRENCY_UPDATE_VENDOR_DETAIL":
      return {
        ...state,
        "orderCurrency": action.payload[0],
        "alternativeCurrency": action.payload[0]
          ? state.alternativeCurrency.filter((code: string) => {
            return action.payload[0] !== code;
          })
          : [],
      };

    case "ON_ADD_VENDOR_DETAIL_BANKDETAIL":
      const minIdval = Math.min(...state.bankDetailList.map((o) => o.id!), 0);
      action.payload[0].id = minIdval >= 0 ? -1 : (minIdval - 1);
      return {
        ...state,
        bankDetailList: [...state.bankDetailList, action.payload[0]],
      };
    case "ON_EDIT_VENDOR_DETAIL_BANKDETAIL":
      return {
        ...state,
        bankDetailList: state.bankDetailList.map((row) => {
          if (row.id === action.payload[0].id) {
            return action.payload[0];
          }
          return row;
        }),
      };
    case "ON_REMOVE_VENDOR_DETAIL_BANKDETAIL":
      return {
        ...state,
        bankDetailList: state.bankDetailList.filter(
          (data) => data.id !== action.payload[0].id
        ),
      };
     case "ON_REMOVE_VENDOR_DETAIL_COMMERCIALDETAIL":
      return {
        ...state,
        commercialDetailList: state.commercialDetailList.filter(
          (data) => data.id !== action.payload[0].id
        ),
      };
    case "ON_REMOVE_VENDOR_DETAIL_PREFFERED_PAYMENT_METHOD":
      return {
        ...state,
        PrefPayMethod: state.PrefPayMethod.filter((code) => {
          return code !== action.payload[0];
        }),
      };
    default:
      return state;
  }
}
